angular.module('messenger').run(['Amateur', 'messenger', (Amateur, messenger) => {

  Amateur.prototype.dialogIsOpen = function () {
    return messenger.dialogIsOpen(this.id);
  };
}]);
